












import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["tip"])
})
export default class TipText extends Vue {

}
